(function() {

  'use strict';

  function EnderecoResource($resource, URL, PATH, URLAPICLIENTE, PUBLIC_API_LUCENE) {
    return $resource(URL + PATH + '/address', {}, {
      getAddress: {
        method: 'GET',
        url: PUBLIC_API_LUCENE + '/address/search?q=:address',
        params: {
          address: '@address'
        }
      },
      activateAddress: {
        method: 'PUT',
        url: URL + PATH + '/addresses/:idEndereco',
        params: {
          idEndereco: '@idEndereco'
        }
      },
      deleteAddress: {
        method: 'DELETE',
        url: URLAPICLIENTE + '/v1/enderecos/:idEndereco',
        params: {
          idEndereco: '@idEndereco'
        }
      },
      addAddress: {
        method: 'POST',
        url: URLAPICLIENTE + '/v1/enderecos',
        isArray: true
      },
      updateReturnAddress: {
        method: 'PUT',
        url: URLAPICLIENTE + '/v1/endereco/:idEndereco/devolucao-padrao',
        params: {
          idEndereco: '@idEndereco'
        }
      },
    });
  }

  angular.module('mandaeApp')
    .factory('EnderecoResource', EnderecoResource);

})();
